<template>
  <v-container class="app">
    <v-row>
      <v-row>
        <v-col cols="12">
          <v-form ref="survey-effort">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="record.observer_code"
                  filled
                  label="Observer 1:"
                  required="true"
                  :rules="required"
                  clearable
                  @input="submit"
                  :disabled="true"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="record.reporter_name"
                  filled
                  label="Reported by:"
                  required="true"
                  :rules="required"
                  clearable
                  @input="submit"
                  :visible="true"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="record.observer_type"
                  :items="refTables['ref_observer_type']"
                  item-text="title"
                  item-value="code"
                  filled
                  label="Observer Type:"
                  clearable
                  @update:modelValue="submit"
                  :visible="true"
                  :disabled="!notSearch"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="record.comment"
                  filled
                  label="Comment:"
                  required="false"
                  clearable
                  @input="submit"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-row>
  </v-container>
</template>

<script>
import { support } from "search-observe-app";

export default {
  name: "Survey-Effort-Form",
  components: {},
  props: {
    notSearch: Boolean,
    selected_record: Object,
  },
  data() {
    return {
      handler: {
        submit: this.submit,
      },
      required: [(v) => !!v || "Required"],
      record: this.selected_record,
    };
  },
  created() {
    this.$watch(
      "selected_record",
      () => {
        this.record = this.selected_record;
        this.submit();
      },
      { deep: true }
    );
    this.$watch(
      "username",
      () => {
        console.log(this.username);
        if (
          this.record_observer_code === "guest" ||
          this.record_observer_code === ""
        ) {
          this.record.observer_code = this.username;
        }
      },
      { deep: true }
    );
    if (
      !this.notSearch &&
      (this.record.observer_code === "guest" ||
        this.record.observer_code === "")
    ) {
      this.record.observer_code = this.username;
    }
  },

  mounted() {
    this.record = this.selected_record;
    if (this.record.observer_code === "guest") {
      this.record.observer_code = this.username;
    }
    this.submit();
  },
  methods: {
    submit() {
      if (
        this.record.observer_code === "guest" ||
        this.record.observer_code === "" ||
        this.record.observer_code === null
      ) {
        this.record.observer_code = this.username;
      }
      if (
        this.record.survey_tablet === "" ||
        this.record.survey_tablet === null
      ) {
        this.record.survey_tablet = this.$store.getters["shared/tabletCode"];
      }
      let record = support.forceFieldType(support.data.SURVEYEFFORTFIELDS, [
        this.record,
      ]);
      record[0].insert_ts = support.getLocalTimestamp(new Date());
      record[0].incidental = "true";
      support.saveRecord(support.data.SURVEYEFFORT, record[0]); //record is a list after force fields
    },
  },
  computed: {
    currentCoordinates() {
      return support.getLatitude() + " " + support.getLongitude();
    },
    showIncidental() {
      return true;
    },
    username: {
      get() {
        return this.$store.getters["shared/username"];
      },
      set(newvalue) {
        this.record.observer_code = newvalue;
      },
    },
    refTables() {
      return this.$store.getters["shared/refTables"];
    },
  },
};
</script>
